// Angular
import { NgModule } from '@angular/core';
import { SectorAirServicesService } from './sector-air-services.service';


@NgModule({
    providers: [
        SectorAirServicesService,
    ],
})
export class SectorAirServicesServiceModule {}